export const buildTimeZone = (province: string) => {
  switch (province) {
    case 'Nova Scotia':
    case '(N.-É.)':
    case 'Nouvelle-Écosse':
      return 'America/Halifax';
    case 'Quebec':
    case 'Québec':
    case '(Qc)':
      return 'America/Toronto';
    case 'Ontario':
    case '(Ont.)':
      return 'America/Toronto';
    case 'Alberta':
    case '(Alb.)':
      return 'America/Edmonton';
    case 'British Columbia':
    case 'Colombie-Britannique':
    case '(C.-B.)':
    case 'BC':
      return 'America/Vancouver';
    case 'Manitoba':
    case '(Man.)':
      return 'America/Winnipeg';
    case 'New Brunswick':
    case 'Nouveau-Brunswick':
      return 'America/Moncton';
    default:
      console.error(
        `Province ${province} not found. Defaulting to PST time zone.`
      );
      return 'America/Vancouver';
  }
};
